import { CircularProgress } from '@material-ui/core';

const Spinner = () => <CircularProgress className="Spinner" color="primary" />;

export default Spinner;
